import { Box, Grid, TextField } from '@mui/material'
import { useState } from 'react'
import Paragraph from '../../../shared/UI/Paragraph'
import Button from '../../../shared/UI/Button'
import { AbsenceDay } from '../../../types/absence-day'

interface SickHoursDetailPanelProps {
  row: AbsenceDay
  location: boolean
  sickHours: number
  validationErrors: any
  isDisabled: boolean
  onSickHoursChange: (rowId: number, value: number) => void
  onValidation: (rowId: number) => boolean
  onUpdate: (rowId: number, sickHours: number, reasonType: string) => void | Promise<unknown>
}

export default function SickHoursDetailPanel({
  row,
  location,
  sickHours,
  validationErrors,
  isDisabled,
  onSickHoursChange,
  onValidation,
  onUpdate,
}: SickHoursDetailPanelProps) {
  const [isUpdating, setIsUpdating] = useState<boolean>(false)

  if (
    !location ||
    row.absenceType.reasonType === 'NonSickness' ||
    row.absenceType.reasonType === 'NoShow'
  ) {
    return null
  }

  return (
    <Box sx={{ margin: 1, p: 1, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
      <Grid
        container
        xs={12}
        mt={1}
        display="inline-flex"
        flexDirection="row"
        sx={{ width: '100%', maxWidth: '100%' }}
      >
        <Grid
          item
          xs={4}
          lg={3}
          xl={2}
          display="inline-flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Paragraph weight="bold">Sick Hours Remaining</Paragraph>
          <Paragraph style={{ marginBottom: '17px' }}>{row.sickPayHoursRemaining}</Paragraph>
        </Grid>
        <Grid item xs={4} lg={3} xl={2} display="inline-flex" flexDirection="column">
          <Paragraph weight="bold">Hours to be paid</Paragraph>
          <TextField
            label="Adjust Hours"
            value={sickHours}
            type="number"
            onChange={e => onSickHoursChange(row.id, +e.target.value)}
            InputProps={{
              inputProps: { min: 0, step: 0.1 },
            }}
            sx={{
              marginTop: '15px',
              paddingRight: '32px',
              '& .MuiInputBase-input': { paddingTop: '14px', paddingBottom: '14px' },
            }}
            error={validationErrors.sickPayHoursRemaining || validationErrors.hoursLost}
          />
        </Grid>
        <Grid item xs={4} lg={3} xl={2} display="inline-flex" alignItems="flex-end">
          <Button
            label="Update"
            loading={isUpdating}
            disabled={isDisabled}
            onClick={async () => {
              if (onValidation(row.id)) {
                setIsUpdating(true)
                try {
                  await onUpdate(row.id, Number(sickHours), row.absenceType.reasonType || '')
                } finally {
                  setIsUpdating(false)
                }
              }
            }}
            style={{ marginTop: '15px', marginLeft: '32px' }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
